import { useState, useEffect, useCallback } from 'react';
import GoldParticles from '@/components/feature/GoldParticles';

export default function LandingOverlay() {
  const [show, setShow] = useState(() => sessionStorage.getItem('tmt-landing-seen') !== 'true');
  const [fadeOut, setFadeOut] = useState(false);

  const startAnimation = useCallback(() => {
    setShow(true);
    setFadeOut(false);

    const fadeTimer = setTimeout(() => setFadeOut(true), 3500);
    const hideTimer = setTimeout(() => {
      setShow(false);
      sessionStorage.setItem('tmt-landing-seen', 'true');
    }, 4500);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  useEffect(() => {
    const cleanup = startAnimation();
    return cleanup;
  }, [startAnimation]);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center transition-opacity duration-1000 ${fadeOut ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
    >
      {/* Luxury Gold Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a05] via-[#1a1408] to-[#0d0b04]" />
      
      {/* Gold radial glow behind logo */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-gradient-radial from-primary-400/8 via-primary-400/3 to-transparent blur-3xl" />

      {/* Gold Particles */}
      <GoldParticles />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-6">
        <div className="w-[320px] md:w-[440px]">
          <img
            src="https://storage.readdy-site.link/project_files/e63cb4d6-832c-48f6-a8a8-3d5a81b53170/ef2d9ce4-6b5a-4db2-a856-a5b8c19adf39_compressed_ChatGPT_Image_Jul_18__2026__03_28_46_PM-removebg-preview.webp"
            alt="T.M.T Trusted Money Transfer"
            className="w-full h-auto object-contain drop-shadow-[0_0_60px_rgba(212,175,55,0.3)] block"
          />
        </div>

        <p className="mt-8 text-primary-400 text-3xl md:text-5xl lg:text-7xl tracking-[0.12em] font-heading italic font-bold text-center animate-glow-pulse animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
          YOUR FUTURE DIGITAL BANK
        </p>
      </div>
    </div>
  );
}